<template>
  <table :class="css.table">
    <thead v-show="!hideHeader">
      <th v-if="withCheckboxes" >
        <input type="checkbox"
               @click="switchChecked"
               :checked="isAnyChecked"
        >
      </th>
      <th v-if="withDetailRow">
      </th>
      <template v-for="column in visibleColumns">
        <th v-if="column.visible!==false"
            @click="column.sortable ? switchSort(column) : void 0"
            :style="column.style"
        >
          <div style="display:flex;align-items: center">
            <span>{{column.title}}</span>
            <span v-if="column.sortable" class="ui icon" style="margin-left:auto;">
                <i :class="getSortClass(column)" :style="getRawSort(column)==undefined?'color:lightgrey;opacity:0.5':''"></i>
            </span>
          </div>
        </th>
      </template>
    </thead>
    <transition-group name="list" tag="tbody">
      <template v-for="(rowData,index) in flatItems">
        <template v-if="isVisibleRow(index)">
          <tr v-if="rowData.group" style="background: #f4f4f4;" :key="index">
            <td :colspan="colspan"
                style="cursor:pointer"
                @click="rowData.expanded=!rowData.expanded">
              <div class="ui icon group-item" :style="{marginLeft:`${rowData.depth*16}px`}">
                <i :class="{angle:true,icon:true,down:rowData.expanded,right:!rowData.expanded}"></i>
                {{getColumnLabel(rowData.item.path)}}: {{getColumnValue(rowData.item) | prettifyValue}}
                <span   v-if="isSortable(rowData.item.path)"
                        @click="switchSort(rowData.item)"
                        class="ui tiny icon button transparent-btn">
                  <i :class="getSortClass(rowData.item)"></i>
                </span>
              </div>

            </td>
          </tr>
          <template v-else>
            <tr :key="index">
              <td v-if="withCheckboxes">
                <input type="checkbox"
                       @click.stop="setChecked(rowData)"
                       :checked="checked[getObjectValue(rowData.item,trackBy)]">
              </td>
              <td v-if="withDetailRow">
                <div class="ui tiny icon button basic transparent-btn" @click.prevent.stop="expandRow(rowData)">
                  <i :class="{angle:true,icon:true,down:isExpanded(rowData),right:!isExpanded(rowData)}"></i>
                </div>
              </td>
              <td v-for="(col,colIndex) in visibleColumns" :style="col.style">
                <template v-if="col.layout||col.layout$">
                  <!--<component :is="col.component" :row-data="rowData.item" :row-index="index" :opts="col.opts"></component>-->
                  <vue-json-layout :layout="col.layout||col.layout$" :model="modelForColumnLayout" :init-data="{rowData:rowData.item}" :key="`${index}-${col.path}`"></vue-json-layout>
                </template>
                <template v-else>
                  {{getObjectValue(rowData.item,col.path) | prettifyValue}}
                </template>
              </td>
            </tr>
            <tr v-if="withDetailRow && isExpanded(rowData)" :key="`${index}-detail`" >
              <td :colspan="colspan">
                <slot  :rowData="rowData.item"></slot>
              </td>
            </tr>
          </template>
        </template>
      </template>
    </transition-group>
    <div v-if="!flatItems.length" style="text-align: center">
      Nothing to display
    </div>
  </table>

</template>
<script>
  import {memoize,get} from 'lodash'
  import moment    from 'moment'

  export default {
    name:"grouping-table",
    props:{
      hideHeader:{
        type:Boolean,
        default:false
      },
      items:{
        type:Array,
        required:true
      },
      columns:{
        type:Array,
        required:true
      },
      withCheckboxes:{
        type:Boolean,
        default: false
      },
      trackBy:{
        type:String,
        default: 'id'
      },
      css:{
        type:Object,
        default(){
          return{
            sort:"sort grey icon",
            sortAscending:"sort ascending icon",
            sortDescending:"sort descending icon",
            table:"ui very basic table "
          }
        }
      },
      groups:{
        type:Array,
        required:true
      },
      withDetailRow:Boolean,
      singleSort:{
        type:Boolean,
        default:true
      },
      modelForColumnLayout:{
        type:Object,
        required:true
      }
    },
    data(){
      return {
        checked:{},
        sort:{},
        sortOrder:[],
        flatItems:null,
        expandedRow:null,
      //  selected:null,
      }
    },
    created(){
      this.getFlatItems();
    },
    computed:{
      isAnyChecked(){
        for(let i = 0 ; i < this.flatItems.length ; i++){
          let id = this.getObjectValue(this.flatItems[i].item,this.trackBy);
          if(this.checked[id])
            return true;
        }
        return false;
      },
      visibleColumns(){
        let self = this;
        return this.columns.filter(col=>col.visible!==false && !self.groups.includes(col.path));
      },
      colspan(){
        return this.visibleColumns.length+(this.withCheckboxes?1:0)+(this.withDetailRow?1:0);
      }

    },
    filters:{
      prettifyValue(val){
        return val!==undefined ? val : "< Нет значения >"
      }
    },
    methods:{
      isExpanded(rowData){
        if(rowData && rowData.item && rowData.item.id!=null && this.expandedRow)
          return rowData.item.id === this.expandedRow.item.id;
        else
          return rowData === this.expandedRow;
      },
      expandRow(rowData){
        if(!this.isExpanded(rowData)) {
          this.expandedRow = rowData
        }else{
          this.expandedRow=null;
        }
      },
      getColumn:memoize(function(path){
        let cols = this.columns.filter(i=>i.path===path);
        if(cols.length){
          return cols[0];
        }
        return null;
      }),
      getColumnLabel(path){
        let col = this.getColumn(path);
        return col ? col.title :"";
      },
      getColumnValue(item){
        if(!item.value) return null;
        let col = this.getColumn(item.path);
        if(col && col.opts && col.opts.schema){
          switch(col.opts.schema.format){
            case 'date':
              return moment(+item.value).format('DD.MM.YYYY');
            case 'time':
              return moment(+item.value).format('hh:mm:ss');
            case 'date-time':
              return moment(+item.value).format('DD.MM.YYYY hh:mm');
          }
        }
        return item.value;
      },
      isSortable(path){
        let cols = this.columns.filter(i=>i.path===path);
        if(cols.length){
          let column = cols[0];
          return column.sortable;
        }
        return false;
      },
      isVisibleRow(index){
        let depth = this.flatItems[index].depth;
        for(let i = index-1; i>=0;i--){
          let currentItem =this.flatItems[i];
          if(currentItem.depth<depth && currentItem.group && !currentItem.expanded){
            return false;
          }
          if(currentItem.depth<depth){
            depth=currentItem.depth;
          }
        }
        return true;
      },
      setChecked(rowData){
        let id = this.getObjectValue(rowData.item,this.trackBy);
        this.$set(this.checked,id,!this.checked[id])
      },
      getFlatItems(){
        let lastGroup = [];
        let res=[];
        let self = this;
        this.items.forEach(groupItem=>{
          let group = groupItem.group.split("$$").filter(i=>i);
          for(let i = 0 ; i<group.length;i++){
            if(lastGroup[i]!==group[i]){
              res.push({
                depth:i,
                group:true,
                expanded:true,
                item:{
                  path:self.groups[i],
                  value:group[i]
                }});
            }
          }
          lastGroup=group;
          res.push(...groupItem.values.map(i=>{return{item:i,depth:group.length}}));
        });
        this.flatItems=res;
      },
      getSort(column){
        return !!this.getRawSort(column);
      },
      getRawSort(column){
        return this.sort[column.path ? column.path : column];
      },
      switchSort(column){
        if (this.sort[column.path]==false){//Третье состояние
          let idx =this.sortOrder.indexOf(column.path);
          if(idx!==-1)this.sortOrder.splice(idx,1);
          this.sort[column.path]=undefined;
          return
        }
        if (this.singleSort){
          this.sortOrder=[column.path];
          const sortSingle={};
          sortSingle[column.path]=this.sort[column.path];
          this.sort=sortSingle;
        }
        let idx =this.sortOrder.indexOf(column.path);
        if(idx!==-1){
          this.sortOrder.splice(idx,1);
        }
        this.sortOrder.unshift(column.path);
        this.$set(this.sort,column.path,!this.getSort(column));
      },
      getSortClass(column){
        let sort = this.getRawSort(column);
        switch(sort){

          case true:
            return this.css.sortAscending;
          case false:
            return this.css.sortDescending;
          default:
            return this.css.sort;
        }
        return this.getSort(column) ? this.css.sortAscending :  this.css.sortDescending;
      },
      switchChecked(){
        let self = this;
        let anyChecked = this.isAnyChecked;
        this.flatItems.forEach(item=>{
          let id = self.getObjectValue(item.item,this.trackBy);
          if(id){
            self.$set(self.checked,id,!anyChecked);
          }
        });
      },
      getObjectValue (object, path, defaultValue) {
        defaultValue = (typeof defaultValue === 'undefined') ? null : defaultValue;

        return get(object,path)||defaultValue

        // let obj = object;
        // if (path.trim() != '') {
        //   let keys = path.split('.');
        //   keys.forEach(function (key) {
        //     if (obj != null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
        //       obj = obj[key]
        //     } else {
        //       obj = defaultValue;
        //
        //     }
        //   })
        // }
        // return obj
      }
    },
    watch:{
      items:{
        handler(newItems){
         this.getFlatItems();
         const refreshChecked={};
         Object.keys(this.checked).forEach(checkedId=>{if(newItems.find(i=>i.id==checkedId))refreshChecked[checkedId]=true});
         this.checked = refreshChecked
        },
        deep:true
      },
      checked:{
        deep:true,
        handler(val){
          let keys = [];
          Object.keys(val).forEach(key=>{if(val[key])keys.push(key)});
          this.$emit("grouping-table:checked",keys);
        }
      },
      sort:{
        deep:true,
        handler(val){
          let res =[];
          this.sortOrder.forEach(path=>res.push({field:path,sort:val[path]?"asc":"desc"}));

          this.$emit("grouping-table:sort",res);
        }
      }


    }
  }
</script>
<style scoped>

  .grouping-table td, .grouping-table th{
    /*padding:8px 16px !important;*/
  }

  .grouping-table th {
    /*min-width:100px;*/
  }
  .grouping-table {
    overflow: auto;
  }
  .grouping-table thead th:first-child,
  .grouping-table tr td:first-child{
    padding-left:16px !important;
  }
  .grouping-table thead th:last-child,
  .grouping-table tr td:last-child{
    padding-right:16px !important;
  }

  .list-enter-active, .list-leave-active {
    transition: all 0.15s;
  }
  .list-enter, .list-leave-to{
    opacity:0;
  }
  .transparent-btn{
    box-shadow:none !important;
    /*opacity: 0;*/
  }
  .selected-row{
    background: #dbe9fb;
  }
  .detail-row{
    max-height:400px;
    padding: 4px 8px;
    overflow: auto;
  }

  /* .group-item:hover > .group-sort-btn{
       opacity: 1;
   }*/
</style>
